import axios from "axios";
import authentication from "@/authentication";

export default {
  async loadPackages(clientIds) {
    await authentication.isAuthenticated();
    return axios
      .get(
        `${process.env.VUE_APP_API_PACKAGE_SERVICE_BASE}/GetPackageDetail?ids=${clientIds}`,
        {
          headers: { Authorization: "Bearer " + authentication.getToken() }
        }
      )
      .then(response => {
        if (typeof response.data === "string") return JSON.parse(response.data);
        else return response.data;
      });
  },
  async loadClients() {
    await authentication.isAuthenticated();
    return axios
      .get(process.env.VUE_APP_API_CLIENT_SERVICE_BASE + "/GetClients", {
        headers: { Authorization: "Bearer " + authentication.getToken() }
      })
      .then(response => {
        return response.data;
      });
  },
  async getExcelDocument(filters) {
    await authentication.isAuthenticated();
    return axios
      .post(
        `${process.env.VUE_APP_API_PACKAGE_SERVICE_BASE}/GetExcelDocument`,
        filters,
        {
          headers: {
            Authorization: `Bearer ${authentication.getToken()}`
          }
        }
      )
      .then(response => {
        return response.data;
      });
  }
};
